import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs';

import { IFilterNumber } from '@shared/models/graphql';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { setUnsavedBedroomsFiltersAction } from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-beds',
  templateUrl: './filter-v2-beds.component.html',
  styleUrls: [
    './filter-v2-beds.component.scss',
    '../filters-v2.component.scss',
  ],
})
export class FilterV2BedsComponent implements OnInit {
  public minValue = 0;
  public maxValue = 0;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loadInitialValue();

    // for clearing the filters
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (
          !filters?.bedrooms ||
          (!filters.bedrooms.greaterThanOrEqual &&
            !filters.bedrooms.lessThanOrEqual)
        ) {
          this.minValue = 0;
          this.maxValue = 0;
        }
      });
  }

  handleChange() {
    if (this.minValue > this.maxValue && this.maxValue > 0) {
      this.maxValue = this.minValue;
    }

    let bedroomsQuery: IFilterNumber = {};
    if (this.minValue > 0) {
      bedroomsQuery.greaterThanOrEqual = this.minValue;
    }
    if (this.maxValue > 0) {
      bedroomsQuery.lessThanOrEqual = this.maxValue;
    }

    this.store.dispatch(setUnsavedBedroomsFiltersAction(bedroomsQuery));
  }

  loadInitialValue() {
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.bedrooms) {
          if (filters.bedrooms.greaterThanOrEqual) {
            this.minValue = filters.bedrooms.greaterThanOrEqual;
          } else {
            this.minValue = 0;
          }
          if (filters.bedrooms.lessThanOrEqual) {
            this.maxValue = filters.bedrooms.lessThanOrEqual;
          } else {
            this.maxValue = 0;
          }
        } else {
          this.minValue = 0;
          this.maxValue = 0;
        }
      });
  }
}
